<template>
  <v-card class="card pa-4 " color="gray10" flat>
    <div class="d-flex title">
      <v-icon>$editList</v-icon>
      <h2 class="font-Light-16 ms-2 ">
        {{ $t("corporateAccount.companyInformation.companyInformation") }}
      </h2>
    </div>

    <p class="font-Light-16 gray2--text my-6">
      {{ $t("corporateAccount.companyInformation.companyInformationNote") }}
    </p>

    <v-card
      class="card d-flex items-center justify-space-between pa-4 mt-3"
      color="gray8"
      flat
    >
      <span class="font-Regular-16">{{ data.name }}</span>
      <div class="">
        <span class="font-Light-14 gray2--text">
          {{ $t("corporateAccount.companyInformation.annualBookDate") }}
          {{ data.registration_date | formatDate }}
        </span>
        <v-icon class="ms-4" clr="var(--v-primary-base)">
          $checkMarkCircleWallet
        </v-icon>
      </div>
    </v-card>
  </v-card>
</template>
<script>
import legalService from "@/services/modules/legalService";

export default {
  name: "CompanyInformation",
  data() {
    return {
      data: null
    };
  },
  mounted() {
    legalService
      .accountDetailsWithMember(this.$cookies.get("CA_ID"))
      .then(response => {
        this.data = response.data.data;
      });
  }
};
</script>
